import { Elements } from '@stripe/react-stripe-js';
import { Radio, Spin } from 'antd';
import ExistingPaymentMethodForm from './ExistingPaymentMethodForm/ExistingPaymentMethodForm';
import { StyledPaymentMethods } from './PaymentMethods.styled';
import NewStripePaymentMethodForm from './NewStripePaymentMethodForm/NewStripePaymentMethodForm';
import usePaymentMethod from './usePaymentMethods.hook';
import NoCostForm from './NoCostForm/NoCostForm';
import useStripePromiseHook from '@/hooks/useStripePromiseHook';
import { useRef } from 'react';

export default function PaymentMethods({
  subscriptionTypeId,
  amount,
  subscriptionParams,
  promotionCode,
}) {
  const elementsRef = useRef();
  const { state, actions } = usePaymentMethod({
    amount,
    elementsRef,
  });
  const stripePromiseRef = useStripePromiseHook();

  return (
    <StyledPaymentMethods>
      {amount > 0 ? (
        <>
          {state.paymentMethods.length ? (
            <div className="existing-payment-methods">
              <Radio.Group
                name="radiogroup"
                defaultValue="existing"
                value={state.mode}
              >
                <Radio
                  value="existing"
                  onChange={(event) => actions.setMode(event.target.value)}
                >
                  Use an existing card
                </Radio>
                <Radio
                  value="new"
                  onChange={(event) => actions.setMode(event.target.value)}
                >
                  Use new card
                </Radio>
              </Radio.Group>
              {state.mode == 'existing' ? (
                <ExistingPaymentMethodForm
                  paymentMethods={state.paymentMethods}
                  subscriptionTypeId={subscriptionTypeId}
                  amount={amount}
                  subscriptionParams={subscriptionParams}
                  promotionCode={promotionCode}
                />
              ) : null}
            </div>
          ) : null}
          {state.mode == 'new' &&
          state.paymentIntent &&
          stripePromiseRef.current ? (
            <Elements
              stripe={stripePromiseRef.current}
              options={{
                clientSecret: state.paymentIntent.client_secret,
              }}
              key={state.paymentIntent.id}
            >
              <NewStripePaymentMethodForm
                paymentIntentId={state.paymentIntent.id}
                subscriptionTypeId={subscriptionTypeId}
                amount={amount}
                subscriptionParams={subscriptionParams}
                futurePayments={state.futurePayments}
                setFuturePayments={actions.setFuturePayments}
                promotionCode={promotionCode}
                elementsRef={elementsRef}
              />
            </Elements>
          ) : state.loading ? (
            <div className="form-loader">
              <Spin spinning={state.loading}></Spin>
            </div>
          ) : null}
        </>
      ) : (
        <NoCostForm
          subscriptionTypeId={subscriptionTypeId}
          amount={amount}
          subscriptionParams={subscriptionParams}
          promotionCode={promotionCode}
        />
      )}
    </StyledPaymentMethods>
  );
}
